import moment from "moment"

export default (value, intl) => {
  return moment().isAfter(value)
    ? intl.formatRelative(value)
    : intl.formatMessage({id: "recognition.polls.openPoll.poll.endsAt"}, {time: intl.formatRelative(value)})
}
